import { create } from 'zustand';
import { getPermissions, setPermissions } from '../../../api/api';

export const usePermissionsStore = create((set) => ({
  isLoading: true,
  error: null,

  loadPermissions: async ({ role, dataCb, errCb }) => {
    if (!role) return;

    set({ isLoading: true, error: null });

    await getPermissions({
      role,
      dataCb: (data) => {
        set({ isLoading: false });
        dataCb?.(data?.sections ?? []);
      },
      errCb: (error) => {
        set({ error, isLoading: false });
        errCb?.(error);
      },
    });
  },

  savePermissions: async ({ values, dataCb, errCb }) => {
    set({ error: null });

    await setPermissions({
      body: {
        role_key: values.role,
        sections: values.sections ?? [],
      },
      dataCb: () => dataCb?.(),
      errCb: (error) => {
        set({ error });
        errCb?.(error);
      },
    });
  },
}));
